import React from 'react'
import Link from 'gatsby-link'
import DiasFaltantes from '../components/countdown'
import Piezas from '../components/piezas'
import AlarmIcon from 'react-icons/lib/md/access-alarm'


const IndexPage = ({data}) => (
  <div>
    <h1>¡Hola!</h1>
    <h3>Bienvenidos a mi Pop Up Store</h3>
    <p><AlarmIcon /> Recuerda que el tiempo pasa rápido y tienes chance de comprar hasta 
    el día <b className="green-text">Domingo 31 de Diciembre</b></p>
    <DiasFaltantes />
    <hr/>
    
    <Piezas data={data.allRecipes.edges} />
  
  </div>
)

export const query = graphql`
	query FronpageQuery{
	  site {
	    siteMetadata {
	      sitetitle
	      proyecttitle
	    }
	  }
		allRecipes {
	    edges {
	      node {
	        title
	        field_excerpt
					fields {
	          slug
	        }
	        vendido
					relationships {
		        image {
		          relationships {
		            imageFile {
		              localFile {
		                childImageSharp {
		                  sizes(maxWidth: 960) {
		                    ...GatsbyImageSharpSizes
		                  }
		                }
		              }
		            }
		          }
		        }
		      }
				}
	    }
	  }	  	
	}
`



export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js